import React from 'react'

const MonitoringDataSIASN = React.lazy(() => import("./MonitoringDataSIASN"))

export const monitoringConfigs = [
    {
        path: '/monitoring/data-asn',
        element: <MonitoringDataSIASN />,
        permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer']
    },
    {
        path: '/monitoring/data-asn/:type',
        element: <MonitoringDataSIASN />,
        permittedRole: ['Operator', 'Administrator', 'Operator Eselon 1', 'Viewer']
    },
]